import { render, staticRenderFns } from "./EntitySection.vue?vue&type=template&id=777b4a06&"
import script from "./EntitySection.vue?vue&type=script&lang=js&"
export * from "./EntitySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports